import React from 'react'
import OwlCarousel from 'react-owl-carousel';
import ObjCategoriesTwoMobile from './ObjCategoriesTwoMobile';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import optionsCategoriesTwoMobile from './OptionsCategoriesTwoMobile';

export const CategoriesTwoMobile = () => {

  return (
    <section className="Section 3 Mobile">
        <OwlCarousel className='owl-theme' loop nav stagePadding autoplay margin={10} {...optionsCategoriesTwoMobile}>
            {ObjCategoriesTwoMobile.map((id) => (
                <section className="categories-two-mobile">
                <div className="categories-two__content-mobile">
                        {
                            <div className='box-mobile' id={id.class}>
                                <div className="box__content-mobile">
                                    <div className="bg-black"></div>
                                    <div className="btn-white">
                                        <a href={id.url} target='_parent'>{id.name}</a>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </section>
            ))}
        </OwlCarousel>
    </section>
  )
}

export default CategoriesTwoMobile